

export interface OfflineDetectionServiceEvent {
  type: 'online' | 'offline'
}
